const PlaceholderPostHorizontal = () => {
    return (
        <div className="row">
            {Array.from({ length: 3}).map((_,index) => (
                <div key={index} className="placeholder bg-white col-md-4 col-12 p-2">
                    <div className="card">
                        <div className="card-header p-0">
                            <div className="placeholder-image" style={{ height: '250px', backgroundColor: '#e0e0e0' }}></div>
                        </div>
                        <div className="card-body text-center">
                            <div className="placeholder-title" style={{ height: '20px', width: '60%', backgroundColor: '#e0e0e0', margin: '10px auto' }}></div>
                            <div className="placeholder-text" style={{ height: '40px', width: '80%', backgroundColor: '#e0e0e0', margin: '10px auto' }}></div>
                            <div className="placeholder-button" style={{ height: '30px', width: '40%', backgroundColor: '#e0e0e0', margin: '10px auto' }}></div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PlaceholderPostHorizontal;
